import { toast } from 'react-toastify';

export const toastNotification = (message, type) => {

    toast[type](message);
}

export const swalNotification = (title, message, type) => {
    Swal.fire({
        title: title,
        text: message,
        icon: type
    });
}

export const getShortText = (text, starting, ending) => {
    if (!text || text == "") return text;
    if (text.length > starting + ending) {
        let output = text.slice(0, starting) + "..."
        if (ending > 0) {
            output += text.slice(-ending);
        }
        return output;
    }
    return text;
}

export const getDecodedFromBackend = (encoded) => {
    let decoded = JSON.parse(atob(encoded));
    return decoded;
}
